"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require("react");
//require('react-selectize/themes/default.css');
// TODO we should be able to use the line above, but it cssify doesn't handle it,
// so we need to use the line below.
// Issue: https://github.com/davidguttman/cssify/issues/23
// Possibly related issue: https://github.com/davidguttman/cssify/issues/46
// browserify-css has the same problem:
// https://github.com/cheton/browserify-css/issues/46
// NOTE: requires copying the files
require('./react-selectize-theme-default.css');
// this doesn't work when bridgedb is a dependency:
//require('../../node_modules/react-selectize/themes/default.css');
var SimpleSelect = require('react-selectize').SimpleSelect;
var WPEntityTypeSelect = (function (_super) {
    __extends(WPEntityTypeSelect, _super);
    function WPEntityTypeSelect(props) {
        var _this = _super.call(this, props) || this;
        var entityTypes = [
            'GeneProduct',
            'Metabolite',
            'Pathway',
            'Protein',
            'Complex',
            'RNA',
            'Unknown',
        ];
        _this.state = {
            options: entityTypes.map(function (entityType) {
                return {
                    label: entityType,
                    value: entityType
                };
            }),
            selected: {
                label: props.entityType,
                value: props.entityType
            }
        };
        return _this;
    }
    WPEntityTypeSelect.prototype.render = function () {
        var that = this;
        var state = that.state;
        return React.createElement(SimpleSelect, { ref: "select", value: state.selected, onValueChange: function (selected) {
                if (!!selected && selected.hasOwnProperty('value')) {
                    that.setState({ selected: selected });
                    that.props.updateHandler(selected.value);
                }
                else {
                    that.setState({ selected: undefined });
                    that.props.updateHandler(undefined);
                }
            }, placeholder: "Select datasource", theme: "default" }, state.options.map(function (o) { return React.createElement("option", { key: o.label, value: o.value }, o.label); }));
    };
    return WPEntityTypeSelect;
}(React.Component));
exports.WPEntityTypeSelect = WPEntityTypeSelect;
// TODO this BioPAX example is just a proof of concept. It has not been tested and is not ready for production.
// also, the code between this and the one above should be DRYed up.
var BioPAXEntityTypeSelect = (function (_super) {
    __extends(BioPAXEntityTypeSelect, _super);
    function BioPAXEntityTypeSelect(props) {
        var _this = _super.call(this, props) || this;
        // TODO check these
        var entityTypes = [
            'GeneReference',
            'DnaReference',
            'SmallMoleculeReference',
            'Pathway',
            'ProteinReference',
            'RnaReference'
        ];
        _this.state = {
            options: entityTypes.map(function (entityType) {
                return {
                    label: entityType,
                    value: entityType
                };
            }),
            selected: {
                label: props.entityType,
                value: props.entityType
            }
        };
        return _this;
    }
    BioPAXEntityTypeSelect.prototype.render = function () {
        var that = this;
        var state = that.state;
        return React.createElement(SimpleSelect, { ref: "select", value: state.selected, onValueChange: function (selected) {
                if (!!selected && selected.hasOwnProperty('value')) {
                    that.setState({ selected: selected });
                    that.props.updateHandler(selected.value);
                }
                else {
                    that.setState({ selected: undefined });
                    that.props.updateHandler(undefined);
                }
            }, placeholder: "Select datasource", theme: "default" }, state.options.map(function (o) { return React.createElement("option", { key: o.label, value: o.value }, o.label); }));
    };
    return BioPAXEntityTypeSelect;
}(React.Component));
exports.BioPAXEntityTypeSelect = BioPAXEntityTypeSelect;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/components/EntityTypeSelect.js
// module id = 122
// module chunks = 0